// Achica fotos antes de subirlas: una foto de celular de 4-8 MB queda en unos
// cientos de KB en WEBP, legible para un DNI o una receta. Los PDF pasan intactos.
// Si el navegador no puede leer la imagen (HEIC, por ejemplo) se devuelve tal cual
// y el servidor decide si la acepta.
export const compressImage = (file, maxWidth = 1200, quality = 0.7) => {
  return new Promise((resolve) => {
    if (!file.type.startsWith('image/') || file.type === 'application/pdf') {
      resolve(file)
      return
    }
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      let w = img.width, h = img.height
      if (w > maxWidth) {
        h = Math.round(h * maxWidth / w)
        w = maxWidth
      }
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, w, h)
      canvas.toBlob((blob) => {
        const compressed = new File([blob], file.name, { type: 'image/webp', lastModified: Date.now() })
        resolve(compressed.size < file.size ? compressed : file)
      }, 'image/webp', quality)
    }
    img.onerror = () => resolve(file)
    img.src = URL.createObjectURL(file)
  })
}
